export function currentMonth() {
  const d = new Date()
  const m = `${d.getMonth() + 1}`.padStart(2, '0')
  return `${d.getFullYear()}-${m}`
}

export function toLocalDatetime(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) {
    const s = String(iso).replace('T', ' ').slice(0, 16)
    return s.includes(' ') ? s.replace(' ', 'T') : ''
  }
  const pad = (n) => `${n}`.padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function fromLocalDatetime(local) {
  if (!local) return ''
  return String(local).length === 16 ? `${local}:00` : String(local)
}

export function emptyPriceDraft() {
  return {
    variant_name: '',
    msrp: '',
    market_price: '',
    secondhand_price: '',
    currency: 'USD',
    price_month: currentMonth(),
    observed_at_local: toLocalDatetime(new Date().toISOString()),
    source_label: '人工录入',
    source_url: ''
  }
}

export function hydratePrices(card) {
  if (!card || !card.prices) return card
  card.prices.forEach((p) => {
    p.observed_at_local = toLocalDatetime(p.observed_at)
    p.secondhand_price = p.secondhand_price || ''
    p.source_label = p.source_label || ''
    p.source_url = p.source_url || ''
  })
  return card
}
